// Keyboard preference for the DatalistSelect custom virtual keyboard fallback.
// "auto" → auto-detect via visualViewport; "on" → always show; "off" → never show.

const KB_PREF_KEY = "vcpl_use_custom_kb";
// Same-tab broadcast so already-mounted pickers pick up a change immediately
// (the native "storage" event only fires in *other* tabs).
export const KB_PREF_EVENT = "vcpl-kbpref";

export const readKbPref = () => {
    if (typeof window === "undefined") return "auto";
    try {
        const v = window.localStorage.getItem(KB_PREF_KEY);
        return v === "on" || v === "off" ? v : "auto";
    } catch {
        return "auto";
    }
};

export const writeKbPref = (v) => {
    try { window.localStorage.setItem(KB_PREF_KEY, v); } catch {}
    try { window.dispatchEvent(new CustomEvent(KB_PREF_EVENT, { detail: v })); } catch {}
};
